module.exports = __webpack_public_path__ + "img/temu.03c1d9bf.png";